import Dialog from "@rio-cloud/rio-uikit/Dialog";
import ConfirmationDialog from "@rio-cloud/rio-uikit/ConfirmationDialog";

interface Props {
  show: boolean;
  onClickContinue: () => void;
  onClickCancel: () => void;
}

const MilkRunConfirm = ({
  show,
  onClickContinue,
  onClickCancel,
}: Props) => {
  return (
    <ConfirmationDialog
      show={show}
      title="Confirme o cálculo MilkRun"
      content="Ao continuar, todas as paradas que não sejam de carregamento ou descarregamento serão excluídas da lista. Deseja continuar?"
      bsSize={Dialog.SIZE_SM}
      onClickConfirm={onClickContinue}
      onClickCancel={onClickCancel}
      cancelButtonText="Voltar"
      confirmButtonText={<span>Continuar</span>}
      useOverflow
    />
  );
};

export default MilkRunConfirm;